import React, { ReactElement, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { useSnackbar } from "notistack";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { apiEndpoint } from "../../Constants/api";

interface RouteParams {
	email: string;
}

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        zIndex: 1,
    },
});

const ForgotPasswordSuccess: React.SFC<{}> = (): ReactElement => {
    const classes = useStyles();

    const location = useLocation<{email: string, query: string}>();

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        document.cookie.split(";").forEach(function(c) {
            document.cookie = c.trim().split("=")[0] + "=;" + "expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        });
    }, []);
    const handleResetEmail = async () => {
        try{
            await fetch(apiEndpoint+"passwordresettokens", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body:  `email=${location.state.email}`
            });
            enqueueSnackbar("Email was sent", {
                autoHideDuration: 3000,
            });
        } catch (error) {
            enqueueSnackbar("Error while sending email", {
                variant: "error",
                autoHideDuration: 3000,
            });
        }
    };
    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot}>
                <Box marginTop="64px" marginBottom="8px">
                    <Typography
                        variant="h2"
                        align="center"
                    >
						Reset Password
                    </Typography>
                </Box>
                <Box marginBottom="32px">
                    <Typography
                        align="center"
                    >
						An email has been sent to {location.state?.email || "user's mail"}. Click the link in the email to reset your password.
                    </Typography>
                </Box>
                <Box
                    marginBottom={"10pt"}
                >
                    <Link to={{pathname: "/login", state: location.state?.query}} style={{textDecoration: "none"}}>
                        <Button
                            type="button"
                            color="primary"
                            variant="contained"
                            data-testid="submitButton"
                            fullWidth
                        >
							Got it
                        </Button>
                    </Link>
                </Box>
                <Button
                    color="default"
                    variant="contained"
                    type="submit"
                    data-testid="submitButton"
                    onClick={() => {
                        handleResetEmail();
                    }}
                    fullWidth
                >
					Resend email
                </Button>
            </Card>
        </Container>
    );
};

export default ForgotPasswordSuccess;
